import create from "zustand";
import { NewToRole, PageLimit, filterSetName } from "../types/stats";
import { School } from "../types/school";
import {
  FilterState,
  FilterAction,
  ManagementFilterAction,
  ManagementFilterState
} from "../types/stats";
import { PermissionData } from "../utils/permissions";

type AdminStore = {
  grade: string | null;
  school: School | null;
  newToRole: NewToRole | null;
  matOnly: boolean;
  isSameOrganisation: boolean;
  isSeeOwnReview: boolean;
  pageLimit: PageLimit | null;
  permissionData: PermissionData | undefined;
  filterState: FilterState;
  managementFilterState: ManagementFilterState;
  filterSetName: filterSetName | null;
  sortingFieldName: string | null;
  grantedPermissionRole: string | undefined;
  questionireTabIndex: any | null;
  sortingOrder: string | null;
  changeFilter: (action: FilterAction) => void;
  changeManagementFilter: (action: ManagementFilterAction) => void;
  setFilters: (action: FilterState) => void;
  setManagementFilters: (action: ManagementFilterState) => void;
  setfilterSetName: (filterSetName: filterSetName) => void;
  setGrantedPermissionRole: (grantedPermissionRole: string | undefined) => void;
  setSortingFieldName: (sortingFieldName: string | null) => void;
  setQuestionireTabIndex: (questionireTabIndex: any | null) => void;
  setSortingOrder: (sortingOrder: string | null) => void;
  selectSchool: (school: School | null) => void;
  selectGrade: (grade: string | null) => void;
  selectNewToRole: (newToRole: NewToRole | null) => void;
  selectPageLimit: (pageLimit: PageLimit | null) => void;
  setMATOnly: (matOnly: boolean) => void;
  setPermissionData: (permissionData: PermissionData) => void;
  setIsSeeOwnReview: (isSeeOwnReview: boolean) => void;
  setIsSameOrganisation: (isSameOrganisation: boolean) => void;
  selectFilterState: (filterState: FilterState) => void;
  selectManagementFilterState: (
    managementFilterState: ManagementFilterState
  ) => void;
};
export const managementFiltersReducer = (
  state: ManagementFilterState,
  action: ManagementFilterAction
): ManagementFilterState => {
  switch (action.type) {
    case "search":
      return { ...state, search: action.value };
    case "searchPermissionList":
      return { ...state, searchPermissionList: action.value };

    case "organisation":
      return { ...state, organisation: action.value };
    case "managementROle":
      return { ...state, managementRole: action.value };
    case "clear":
      // if (action.filter === "grade") {
      //   return { ...state, grade: "All" };
      // }
      return { ...state, [action.filter]: null };
    case "clearAll":
      return managementFiltersInitialState;
    default:
      return { ...state };
  }
};
export const filtersReducer = (
  state: FilterState,
  action: FilterAction
): FilterState => {
  switch (action.type) {
    case "search":
      return { ...state, search: action.value };
    // case "grade":
    //   return { ...state, grade: action.value };
    case "grade":
      return { ...state, grade: action.value };
    case "newToRole":
      return { ...state, newToRole: action.value };

    case "pageLimit":
      return { ...state, pageLimit: action.value };
    case "impact_of_leaving":
      return { ...state, impact_of_leaving: action.value };
    case "likelyPromotionYear":
      return { ...state, likelyPromotionYear: action.value };
    case "riskOfLeaving":
      return {
        ...state,
        riskOfLeaving: action.value,
        riskOfLeavingYears: "QR38"
      };
    case "riskOfLeavingYears":
      return { ...state, riskOfLeavingYears: action.value };
    case "responsibility":
      return {
        ...state,
        responsibility: action.multipleOption
          ? Array.isArray(action.value)
            ? action.value
            : [action.value]
          : action.value || []
      };
    case "removeResponsibility":
      return {
        ...state,
        responsibility: []
      };
    case "dept":
      return { ...state, dept: action.value };
    case "designation":
      return { ...state, designation: action.value };
    case "staffgrade":
      return {
        ...state,
        staffgrade: action.multipleOption
          ? Array.isArray(action.value)
            ? action.value
            : [action.value]
          : action.value || []
      };
    case "removeStaffgrade":
      return {
        ...state,
        staffgrade: []
      };
    case "highestQlfy":
      return {
        ...state,
        highestQlfy: action.multipleOption
          ? Array.isArray(action.value)
            ? action.value
            : [action.value]
          : action.value || []
      };
    case "removeHighestQlfy":
      return {
        ...state,
        highestQlfy: []
      };
    case "lineManager":
      return { ...state, lineManager: action.value };
    case "highestRole":
      return { ...state, highestRole: action.value };
    case "nextRole":
      return { ...state, nextRole: action.value };
    case "clear":
      // if (action.filter === "grade") {
      //   return { ...state, grade: "All" };
      // }
      if (action.filter === "riskOfLeaving") {
        return { ...state, [action.filter]: null, riskOfLeavingYears: null };
      }
      return { ...state, [action.filter]: null };

    case "setBespokeFilter":
      const updatedBespokeFilters = {
        ...state.bespokeFilters,
        [action.filterName]: action.multipleOption
          ? Array.isArray(action.value)
            ? action.value
            : [action.value]
          : action.value
      };
      const cleanedBespokeFilters = Object.fromEntries(
        Object.entries(updatedBespokeFilters).filter(
          ([key, value]) =>
            value !== null && (Array.isArray(value) ? value.length > 0 : true)
        )
      );
      return {
        ...state,
        bespokeFilters: cleanedBespokeFilters
      };

    case "removeBespokeFilter":
      const updatedFilters = { ...state.bespokeFilters };
      delete updatedFilters[action.filterName];
      const isBespokeFiltersEmpty = Object.keys(updatedFilters).length === 0;

      return {
        ...state,
        bespokeFilters: isBespokeFiltersEmpty ? {} : updatedFilters
      };

    case "clearAll":
      return filtersInitialState;
    default:
      return {
        ...state,
        bespokeFilters: {},
        multipleOption: {},
        highestQlfy: []
      };
  }
};

export const filtersInitialState: FilterState = {
  // grade: "All",
  newToRole: "All",
  pageLimit: "20",
  grade: null,
  impact_of_leaving: null,
  likelyPromotionYear: null,
  riskOfLeaving: null,
  responsibility: [],
  dept: null,
  designation: null,
  riskOfLeavingYears: null,
  search: undefined,
  staffgrade: [],
  highestQlfy: [],
  lineManager: null,
  highestRole: null,
  nextRole: null,
  multipleOption: {},
  bespokeFilters: {}
};
export const managementFiltersInitialState: ManagementFilterState = {
  organisation: null,
  managementRole: null,
  search: undefined,
  searchPermissionList: undefined
};
export const useAdminStore = create<AdminStore>(set => ({
  grade: null,
  school: null,
  matOnly: false,
  filterSetName: null,
  permissionData: undefined,
  grantedPermissionRole: undefined,
  sortingFieldName: null,
  questionireTabIndex: 0,
  sortingOrder: null,
  newToRole: "ALL",
  pageLimit: "20",
  isSeeOwnReview: false,
  isSameOrganisation: false,
  filterState: filtersInitialState,
  managementFilterState: managementFiltersInitialState,
  setFilters: (filters: Partial<FilterState>) =>
    set(_state => {
      return {
        filterState: {
          ...filtersInitialState,
          ...filters
        }
      };
    }),
  setManagementFilters: (
    managementRoleFilters: Partial<ManagementFilterState>
  ) =>
    set(_state => {
      return {
        managementFilterState: {
          ...managementFiltersInitialState,
          ...managementRoleFilters
        }
      };
    }),
  changeFilter: (action: FilterAction) =>
    set(state => {
      return {
        filterState: filtersReducer(state.filterState, action)
      };
    }),
  changeManagementFilter: (action: ManagementFilterAction) =>
    set(state => {
      return {
        managementFilterState: managementFiltersReducer(
          state.managementFilterState,
          action
        )
      };
    }),
  selectGrade: (grade: string | null) =>
    set(state => {
      return {
        grade,
        filterState: { ...state.filterState, grade: grade }
      };
    }),
  selectPageLimit: (pageLimit: PageLimit | null) =>
    set(state => ({
      pageLimit,
      filterState: { ...state.filterState, pageLimit: pageLimit ?? "20" }
    })),
  setMATOnly: (matOnly: boolean) => set(state => ({ matOnly })),
  setIsSeeOwnReview: (isSeeOwnReview: boolean) =>
    set(state => ({ isSeeOwnReview })),
  setPermissionData: (permissionData: PermissionData) =>
    set(state => ({ permissionData })),
  setIsSameOrganisation: (isSameOrganisation: boolean) =>
    set(state => ({ isSameOrganisation })),
  setfilterSetName: (filterSetName: filterSetName | null) =>
    set(state => ({
      filterSetName
    })),
  setSortingFieldName: (sortingFieldName: string | null) =>
    set(state => ({
      sortingFieldName
    })),
  setSortingOrder: (sortingOrder: string | null) =>
    set(state => ({
      sortingOrder
    })),
  setGrantedPermissionRole: (grantedPermissionRole: string | undefined) =>
    set(state => ({
      grantedPermissionRole
    })),
  setQuestionireTabIndex: (questionireTabIndex: any | null) =>
    set(state => ({
      questionireTabIndex
    })),
  selectSchool: (school: School | null) =>
    set(state => ({ matOnly: false, school })),
  selectNewToRole: (newToRole: NewToRole | null) =>
    set(state => ({
      newToRole,
      filterState: { ...state.filterState, newToRole: newToRole ?? "All" }
    })),
  selectFilterState: (filterState: FilterState) =>
    set(state => ({ filterState })),
  selectManagementFilterState: (managementFilterState: ManagementFilterState) =>
    set(state => ({ managementFilterState }))
}));
